interface SectionHeadingProps {
  tag?: string;
  title: string;
  subtitle?: string;
}

const SectionHeading = ({ tag, title, subtitle }: SectionHeadingProps) => (
  <div className="text-center mb-12 reveal-up">
    {tag && (
      <span className="inline-block ttk-section-tag mb-4 px-4 py-2 rounded-full">
        {tag}
      </span>
    )}
    <h2 className="ttk-section-title font-bold mb-4">{title}</h2>
    {subtitle && <p className="ttk-section-subtitle max-w-2xl mx-auto">{subtitle}</p>}
  </div>
);

export default SectionHeading;
